@if (loaded()) {
  <div class="report-container">
    <div class="outcome">
      <hyperkit-typography variant="h4">Outcome</hyperkit-typography>
      <hyperkit-typography variant="body" size="md">{{
        huntView.outcome()
      }}</hyperkit-typography>
    </div>
    <report-text-block
      title="Elaborate on outcome"
      [value]="huntView.outcomeDependent()"
    ></report-text-block>
    <report-text-block
      title="Conclusion"
      [value]="huntView.conclusion()"
    ></report-text-block>
  </div>
} @else {
  <p>Loading…</p>
}
